import React, { useState } from "react";
import ButtonDisable from "../../partials/other/ButtonDisable";

export default function AddSiteUserAdvertiser() {
  const [showInput, setShowInput] = useState(false);

  return (
    <div className="py-2">
      <div class="alert alert-warning ">
        <p>
          <i class="fa fa-info pl-2"></i>توجه داشته باشید :{" "}
        </p>
        <ul class="pr-3">
          <li>
            <p>
              <span>آدرس سایت باید دارای </span>
              <span dir="ltr" className="px-1">
                http://
              </span>
              <span>یا</span>
              <span dir="ltr" className="px-1">
                https://
              </span>
              <span> و بدون حرف</span>
              <span className="px-1">/</span>
              <span>باشد </span>
              <span>به طور مثال : </span>
              <span>https://example.ir</span>
            </p>
          </li>
        </ul>
      </div>

      <div className="d-flex flex-column  flex-lg-row">
        <div
          className="btn btn-success"
          onClick={() => {
            setShowInput((prevState) => {
              return !prevState;
            });
          }}
        >
          <span className="pl-2">
            <i className="fa fa-plus"></i>
          </span>
          <span>اضافه کردن سایت تبلیغ دهنده</span>
        </div>
        <div
          className={` pt-2 pr-0 pt-lg-0 pr-lg-2 ${
            showInput == true ? "" : "d-none"
          } `}
        >
          <form className="d-flex">
            <div>
              <input
                dir="ltr"
                id="website-url"
                className="form-control"
                placeholder="https://example.ir"
                required
              />
            </div>
            <div className="pr-2">
              <ButtonDisable
                buttonTagHtml={
                  <span className="btn btn-success opacity-50">درج</span>
                }
              ></ButtonDisable>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
